"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hidePatientRel = exports.formatProviderDegrees = exports.formatProviderName = exports.getNextAvailableDate = exports.formatDateForHeading = exports.filterAvailabilityByLocationByDate = exports.getDefaultPurposes = exports.locationsHaveAvailability = exports.groupAvailabilityByLocationId = exports.logAppointmentInfoChange = exports.getLogger = exports.getDisabledRelationships = exports.getVisitMethodGroupOptions = exports.getEnableVisitMethodGroups = exports.getVisitMethodGroup = exports.getVisitMethodMessage = exports.getInitialPurpose = void 0;
const moment_1 = __importDefault(require("moment"));
const types_1 = require("../../../types");
const globals_1 = require("../../../common/util/constants/globals");
const messages_1 = require("../messages");
const constants_1 = require("../constants");
/**
 * Get the initial purpose for an appointment
 * @param appointmentInfo
 * @param purposeOptionsByRelationship
 * @returns {PurposeOption}
 */
const getInitialPurpose = (appointmentInfo, purposeOptionsByRelationship) => {
    if (!appointmentInfo.purpose || !appointmentInfo.relationship)
        return undefined;
    const { relationship, purpose } = appointmentInfo;
    const patientRelationship = relationship === types_1.PatientRelationship.NEW
        ? types_1.PatientRelationship.NEW
        : types_1.PatientRelationship.ESTABLISHED;
    const options = purposeOptionsByRelationship[patientRelationship] || [];
    return options.find((option) => option.name === purpose);
};
exports.getInitialPurpose = getInitialPurpose;
/**
 * Get the visit method translation
 * @param visitMethod
 * @returns string
 */
const getVisitMethodMessage = (visitMethod) => {
    switch (visitMethod) {
        case types_1.VisitType.IN_PERSON:
            return messages_1.messages.visitTypeInPerson;
        case types_1.VisitType.VIDEO:
            return messages_1.messages.visitTypeVideo;
        case types_1.VisitType.PHONE:
            return messages_1.messages.visitTypePhone;
        default:
            return messages_1.messages.visitTypeInPerson;
    }
};
exports.getVisitMethodMessage = getVisitMethodMessage;
/**
 * Get the visit method group for a given visit method
 * @param visitMethod
 * @returns VisitMethodGroup
 */
const getVisitMethodGroup = (visitMethod) => {
    switch (visitMethod) {
        case types_1.VisitType.IN_PERSON:
            return types_1.VisitMethodGroup.InPerson;
        case types_1.VisitType.VIDEO:
        case types_1.VisitType.PHONE:
            return types_1.VisitMethodGroup.Virtual;
        default:
            return null;
    }
};
exports.getVisitMethodGroup = getVisitMethodGroup;
/**
 * Determine if the visit method group options should be shown
 * @param purposeOptionsByRelationship
 * @returns VisitMethodGroup[]
 */
const getEnableVisitMethodGroups = (purposeOptionsByRelationship, relationship) => {
    const options = [...(purposeOptionsByRelationship[relationship] || [])];
    const groups = options.reduce((acc, option) => {
        const group = (0, exports.getVisitMethodGroup)(option.visit_method);
        if (group === null)
            return acc;
        if (!acc.includes(group)) {
            acc.push(group);
        }
        return acc;
    }, []);
    if (groups.length === 2)
        return true;
    return false;
};
exports.getEnableVisitMethodGroups = getEnableVisitMethodGroups;
/**
 *  Get the purpose options for a given relationship and visit method group
 * @param purposeOptionsByRelationship
 * @param relationship
 * @param visitMethodGroup
 * @returns
 */
const getVisitMethodGroupOptions = (purposeOptionsByRelationship, relationship, visitMethodGroup) => {
    const options = purposeOptionsByRelationship[relationship] || [];
    const visitMethodGroupsEnabled = (0, exports.getEnableVisitMethodGroups)(purposeOptionsByRelationship, relationship);
    if (visitMethodGroupsEnabled === false)
        return options;
    return options.filter((option) => (0, exports.getVisitMethodGroup)(option.visit_method) === visitMethodGroup);
};
exports.getVisitMethodGroupOptions = getVisitMethodGroupOptions;
/**
 * Determine which relationships are disabled
 * @param purposeOptionsByRelationship
 * @returns { new: boolean, established: boolean }
 */
const getDisabledRelationships = (purposeOptionsByRelationship) => {
    return {
        new: purposeOptionsByRelationship.new == null ||
            purposeOptionsByRelationship.new.length === 0,
        established: purposeOptionsByRelationship.established == null ||
            purposeOptionsByRelationship.established.length === 0
    };
};
exports.getDisabledRelationships = getDisabledRelationships;
/**
 * Return a logging function with a message prefix
 * @param log
 * @param additionalData
 * @returns {LoggingFunction}
 */
const getLogger = (log, additionalData) => (message, data) => {
    const eventData = Object.assign(Object.assign({}, data), additionalData);
    log(message, eventData);
};
exports.getLogger = getLogger;
const logAppointmentInfoChange = (log, button, value) => {
    if (typeof value === 'object') {
        log(globals_1.LOGGING.MESSAGE.APPOINTMENT_INFO_CHANGED, Object.assign({ button }, value));
    }
    if (typeof value === 'string') {
        log(globals_1.LOGGING.MESSAGE.APPOINTMENT_INFO_CHANGED, {
            button,
            value
        });
    }
};
exports.logAppointmentInfoChange = logAppointmentInfoChange;
/**
 * Given slots returned from the API,
 * group Slots into objects with location_id as the key
 * @param slots
 * @returns
 */
const groupAvailabilityByLocationId = (slots) => {
    return slots.reduce((acc, slot) => {
        if (!acc[slot.location_id]) {
            acc[slot.location_id] = [];
        }
        acc[slot.location_id].push(slot);
        return acc;
    }, {});
};
exports.groupAvailabilityByLocationId = groupAvailabilityByLocationId;
/**
 * Determine if at least one location has availability
 * @param availability
 * @param locations
 * @returns
 */
const locationsHaveAvailability = (availability, locations) => {
    if (Object.keys(availability).length === 0)
        return false;
    return locations.some((location) => {
        var _a;
        return availability[location.id] && ((_a = availability[location.id]) === null || _a === void 0 ? void 0 : _a.length);
    });
};
exports.locationsHaveAvailability = locationsHaveAvailability;
/**
 * Get default purpose options
 * @param purposeOptionsByRelationship
 * @returns {DefaultPurposeOptionsByRelationship}
 */
const getDefaultPurposes = (purposeOptionsByRelationship) => {
    var _a, _b;
    return ({
        [types_1.PatientRelationship.ESTABLISHED]: (_a = purposeOptionsByRelationship.established) === null || _a === void 0 ? void 0 : _a.find((p) => p.default),
        [types_1.PatientRelationship.NEW]: (_b = purposeOptionsByRelationship.new) === null || _b === void 0 ? void 0 : _b.find((p) => p.default)
    });
};
exports.getDefaultPurposes = getDefaultPurposes;
/**
 * Given availability grouped by location
 * filter the slots by date
 * @param availability
 * @param date
 * @returns
 */
const filterAvailabilityByLocationByDate = (availability, selectedDate) => {
    const filteredAvailability = {};
    for (const locationId in availability) {
        filteredAvailability[locationId] = availability[locationId].filter((slot) => {
            return slot.date === selectedDate;
        });
    }
    return filteredAvailability;
};
exports.filterAvailabilityByLocationByDate = filterAvailabilityByLocationByDate;
/**
 * Given a date from a slot, format it for the date heading
 * @param date
 * @returns
 */
const formatDateForHeading = (date) => {
    return date ? (0, moment_1.default)(date).format('ddd, MMMM D') : '';
};
exports.formatDateForHeading = formatDateForHeading;
const getNextAvailableDate = ({ availability, selectedDate, selectedLocation }) => {
    var _a;
    if (!selectedDate || Object.values(availability).length === 0) {
        return undefined;
    }
    let locationSlots = [];
    if (selectedLocation) {
        locationSlots = availability[selectedLocation];
    }
    else {
        locationSlots = Object.values(availability).reduce((acc, slots) => {
            return acc.concat(slots);
        }, []);
    }
    const sortedSlots = locationSlots
        .filter((slot) => slot.date > selectedDate)
        .sort((a, b) => a.date.localeCompare(b.date));
    return (_a = sortedSlots[0]) === null || _a === void 0 ? void 0 : _a.date;
};
exports.getNextAvailableDate = getNextAvailableDate;
const formatProviderName = ({ name, degrees }) => {
    const formattedDegrees = (0, exports.formatProviderDegrees)(degrees);
    // account for both v8 and v9 data while in transition (appt-cancel flow hits v8)
    // TODO: remove the fallback logic when both flows use search v9
    const fullName = (name === null || name === void 0 ? void 0 : name.full) || (name === null || name === void 0 ? void 0 : name.full_name);
    return [fullName, formattedDegrees ? ` ${formattedDegrees}` : null]
        .filter((v) => !!v)
        .join();
};
exports.formatProviderName = formatProviderName;
const formatProviderDegrees = (degrees) => degrees
    .filter(({ name }) => !!name)
    .map(({ name }) => name)
    .join(',');
exports.formatProviderDegrees = formatProviderDegrees;
/**
 * Determines whether or not we should hide the patient relationship question on the ApptInfo
 * step in the flow based on the provider.entity_type and a config flag (hide_patient_rel_for_locations)
 * @param {object} provider a provider or bookable entity (e.g. location/clinic)
 * @param {boolean} hidePatientRelForLocations config flag; true means hide the patient rel question
 * @param returns true if we should hide the patient rel question, else false
 */
const hidePatientRel = (provider, hidePatientRelForLocations) => {
    var _a, _b;
    if (provider[constants_1.ENTITY_TYPE] &&
        provider[constants_1.ENTITY_TYPE] === constants_1.LOCATION_ENTITY_TYPE &&
        hidePatientRelForLocations === true) {
        return true;
    }
    if ((_b = (_a = provider === null || provider === void 0 ? void 0 : provider.patient_rel_question) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.hidden) {
        // this value will come back to us from XP as a string
        // if any string is set, other than an empty string (which is false-y), the question will be hidden
        return true;
    }
    return false;
};
exports.hidePatientRel = hidePatientRel;
//# sourceMappingURL=index.js.map